import { IRegion } from '../models';
import { $api } from '../service';

export const getRegions = async () => {
  const { data } = await $api.get<IRegion[]>('/address');

  return data;
};
